import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { api } from "../lib/api";

const LS_KEY = "ownercam_report_lang";

/* Static fallback so the picker renders even before /api/i18n/languages
   returns. Server is authoritative. */
const FALLBACK_LANGS = [
  { code: "en", name_en: "English", name_native: "English", flag: "🇬🇧" },
];

const I18nContext = createContext({
  lang: "en",
  setLang: () => {},
  languages: FALLBACK_LANGS,
});

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem(LS_KEY) || "en";
    } catch {
      return "en";
    }
  });
  const [languages, setLanguages] = useState(FALLBACK_LANGS);

  useEffect(() => {
    let alive = true;
    api.get("/i18n/languages")
      .then((r) => { if (alive && Array.isArray(r.data?.languages)) setLanguages(r.data.languages); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  const setLang = useCallback((code) => {
    setLangState(code);
    try { localStorage.setItem(LS_KEY, code); } catch { /* ignore */ }
  }, []);

  const value = useMemo(() => ({ lang, setLang, languages }), [lang, setLang, languages]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
